import { useEffect, useState } from "react";

import { t } from "i18next";
import { useTranslation } from "react-i18next";

import CustomModal from "../../packages/CustomModal";
import IconButton from "../../packages/IconButton";
import WPTertiaryButton from "../../packages/WPTertiaryButton";

import PlantTrainsAccordion from "./PlantTrainsAccordion";

import { MAX_TRAINS_FOR_BENCHMARK } from "../../constants/global.constants";

import {
  BenchmarkGuide,
  BenchmarkGuideZh,
  CloseIcon,
  ExpandIcon,
} from "../../assets/icons";

import "./Benchmark.scss";

const Benchmark = ({
  setIsBenchmarkMode,
  selectedPlants,
  benchmarkPlantTrains,
  setBenchmarkPlantTrains,
  selectedTrainsCount,
}) => {
  const { i18n } = useTranslation();
  const [showEnlargedGuide, setShowEnlargedGuide] = useState(false);
  const isChinese = i18n.language?.startsWith("zh");
  const BenchmarkGuideImage = isChinese ? BenchmarkGuideZh : BenchmarkGuide;

  const handleClose = () => {
    setIsBenchmarkMode(false);
  };

  const handleGuideEnlarge = () => {
    setShowEnlargedGuide(true);
  };
  useEffect(() => {
    setBenchmarkPlantTrains((prev) => {
      const validTrainsByPlant = {};
      selectedPlants.forEach((plant) => {
        validTrainsByPlant[String(plant.plant_id)] = plant.trains.map(
          (t) => t.train_id,
        );
      });

      const newBenchmarkPlantTrains = {};
      for (const plantId in prev) {
        if (validTrainsByPlant[plantId]) {
          const validTrainIds = validTrainsByPlant[plantId];
          const filteredTrains = prev[plantId].filter((id) =>
            validTrainIds.includes(id),
          );
          newBenchmarkPlantTrains[plantId] = filteredTrains;
        }
      }
      return newBenchmarkPlantTrains;
    });
  }, [selectedPlants]);

  return (
    <div className="benchmark-container">
      <div className="benchmark-header-container">
        <div className="benchmark-header">
          {t("benchMark.selectTrains")} ({selectedTrainsCount}/
          {MAX_TRAINS_FOR_BENCHMARK})
        </div>
        <IconButton
          tooltip={t("benchMark.exitBenchmark")}
          placement="bottom"
          onClick={handleClose}
        >
          <WPTertiaryButton
            icon={<CloseIcon />}
            className="exit-button"
            preventDefault={false}
          />
        </IconButton>
      </div>
      <div className="benchmark-content-container">
        {selectedPlants && selectedPlants.length > 0 ? (
          <PlantTrainsAccordion
            plants={selectedPlants}
            benchmarkPlantTrains={benchmarkPlantTrains}
            setBenchmarkPlantTrains={setBenchmarkPlantTrains}
            selectedTrainsCount={selectedTrainsCount}
          />
        ) : (
          <div className="no-plants-container">
            <div className="no-plants">{t("benchMark.noPlantsSelected")}</div>
            <div className="benchmark-guide-container">
              <ExpandIcon
                className="expand-icon"
                onClick={handleGuideEnlarge}
              />
              <BenchmarkGuideImage
                className="benchmark-guide"
                onClick={handleGuideEnlarge}
              />
            </div>
          </div>
        )}
      </div>
      {showEnlargedGuide && (
        <CustomModal
          width="550px"
          hideFooter
          custombodyclass="enlarged-guide-modal-body"
          onModalClose={() => setShowEnlargedGuide(false)}
        >
          <BenchmarkGuideImage className="enlarged-guide" />
        </CustomModal>
      )}
    </div>
  );
};

export default Benchmark;
